import { useRuntimeConfig } from '#imports'

import type { LoggerConfiguration } from '@backmarket/front-logger'
import { useSessionId } from '@backmarket/nuxt-module-identification/useSessionId'
import { useVisitorId } from '@backmarket/nuxt-module-identification/useVisitorId'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

export function useAttributes() {
  const config = useRuntimeConfig().public.logger

  const { market } = useMarketplace()
  const visitorId = useVisitorId()
  const sessionId = useSessionId()

  const attributes: LoggerConfiguration['attributes'] = {
    environment: config.environment,
    source: process.server ? 'node' : 'browser',

    countryCode: market.countryCode,
    marketplaceCode: market.marketplace,

    bm: {
      session_id: sessionId,
      visitor_id: visitorId,
    },

    service: {
      name: config.service,
      version: config.buildImage.version,
      build: {
        timestamp: config.buildImage.timestamp,
        sha: config.buildImage.sha,
      },
    },
  }

  return attributes
}
